// var ProgressBar = require('progressbar.js')
import ProgressBar from 'progressbar.js/dist/progressbar'

const progress_bar_el = document.getElementById('progress_bar_v2')
if (progress_bar_el) {

// progressbar.js@1.0.0 version is used
// Docs: http://progressbarjs.readthedocs.org/en/1.0.0/
  var bar = new ProgressBar.SemiCircle('#progress_bar_v2', {
    strokeWidth: 2,
    color: '#233976',
    trailColor: '#eee',
    trailWidth: 2,
    easing: 'easeInOut',
    duration: 1400,
    svgStyle: null,
    text: {
      value: '',
      alignToBottom: false
    },
    from: { color: '#233976' },
    to: { color: '#233976' },
    // Set default step function for all animate calls
    step: (state, bar) => {
      bar.path.setAttribute('stroke', state.color)
      var value = Math.round(bar.value() * 100)
      if (value === 0) {
        bar.setText('')
      }
      else {
        // bar.setText(value);
      }

      bar.text.style.color = state.color
    }
  })
  bar.path.style.strokeLinecap = 'round'
}

(function () {

  const infoGraphicElementList = document.querySelectorAll('.js_info_graphic_element')

  if (infoGraphicElementList.length) {
    const elementCount = infoGraphicElementList.length
    const stepPercentage = 100 / elementCount
    let percentage = 1 * stepPercentage
    initInfoGraphic(infoGraphicElementList, stepPercentage)

  }

  function initInfoGraphic (igList, stepPercent) {
    for (var i = 0; i < igList.length; i++) {
      const element = igList[i]
      const btnList = element.querySelectorAll('.js__info_graphic_action_btn')
      const infoGraphicCurrentIndex = element.dataset.ige_index
      const infoGraphicLength = element.dataset.ige_length

      // Hide first element prev button
      if (i === 0) {
        btnList[0].classList.add('d-none')
      }

      // Hide last element next button
      if (i === igList.length - 1) {
        btnList[1].classList.add('d-none')
      }

      // Progress bar on start
      bar.animate(stepPercent / 100)  // Number from 0.0 to 1.0

      // Handle btn click
      for (var j = 0; j < btnList.length; j++) {
        const btn = btnList[j]
        const direction = btn.dataset.direction
        btn.addEventListener('click', function () {
          moveInfoGraphicElement(direction, infoGraphicCurrentIndex, infoGraphicLength, stepPercent)
        })
      }
    }
  }

  function moveInfoGraphicElement (direction, index, length, stepPercent) {

    const currentElement = document.getElementById('info-graphic-element--' + index)
    const nextElement = document.getElementById('info-graphic-element--' + (parseInt(index) + 1))
    const prevElement = document.getElementById('info-graphic-element--' + (parseInt(index) - 1))

    currentElement.classList.remove('active')

    if (direction === 'next') {
      nextElement.classList.add('active')

      // For animate - Number from 0.0 to 1.0
      bar.animate((stepPercent * (parseInt(index) + 1)) / 100)

    }
    if (direction === 'prev') {
      prevElement.classList.add('active')
      // For animate - Number from 0.0 to 1.0
      bar.animate((stepPercent * (parseInt(index) - 1)) / 100)
    }
  }

})()





